<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
           
                <p class="sub-header">
                    {{$t('string.msg.companies.search.parts.truck.description')}}
                </p>

                <form>
                    <div class="form-row">
                       
                        <div class="form-group col-md-6">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.companies.search.label.name')}}
                            </label>
                            <input type="text" v-model="filters.name" class="form-control">
                        </div>
                    </div>

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                         <div v-if="items && items.length > 0">
                            <download-excel v-if="filters.typeService==''"
                                class   = "btn btn-primary"
                                :fetch   = "fetchData"
                                :fields = "json_fields"
                                :meta = "json_meta"
                                type    = "csv"
                                name    = "associados-geral.xls">
                                Download CSV
                            </download-excel>
                             <download-excel v-else-if="filters.typeService=='PART_SUPPLIER'"
                                class   = "btn btn-primary"
                                :fetch   = "fetchData"
                                :fields = "json_fields"
                                :meta = "json_meta"
                                type    = "csv"
                                name    = "auto-peças.xls">
                                Download CSV
                            </download-excel>
                         </div>
                    </div>
                </form>

                <div class="pb-0 pt-3 ">
                        <jw-pagination :items="items" @changePage="onChangePage"></jw-pagination>
                </div>
                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.company.label.fantasyName')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.document')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.type')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.main.email')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.primaryPhone')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer" @click="selectItem(item)">
                                <td>
                                    <span>
                                        {{toUpperCase(item.socialName)}}
                                    </span>
                                </td>
                                <td>
                                    <input type="tel" v-mask="['###.###.###-##', '##.###.###/####-##']"  readonly class="form-control reset-input" :value="item.document">
                                </td>
                                <td>
                                    <p>
                                        {{item.typeService.includes("SERVICE_PROVIDER") ? $t('string.msg.company.label.type.serviceprovider') : ''}}
                                    </p>
                                    <p>    
                                        {{item.typeService.includes("PART_SUPPLIER") ? $t('string.msg.company.label.type.autoparts'): ''}}
                                    </p>
                                    <p>
                                        {{item.typeService.includes("CERTIFIER") ? $t('string.msg.company.label.type.certifier') : ''}}
                                    </p>
                                      <p>
                                        {{item.typeService.includes("FLEET_DRIVER") ? $t('string.msg.company.label.type.fleetdriver') : ''}}
                                    </p>
                                </td>
                                <td>
                                    <span>
                                        {{(item.email)}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{(item.primaryPhone)}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
           <Toast :title="titleToast" :message="messageToast" />
    </div>
</template>

<script>
import Controller from './CrtListCompanies';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'ListCompanies',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        PageNumbers:1,
        items: [],
        pageOfItems: [],
        filters: {
            name: '',
            typeService: 'PART_SUPPLIER',
                 status:'ACTIVE',
            isHideDetailsManufecturerFamily: false,
            isHideDetailsCertifies: true,
            isHideDetailsServiceFamilies: true,
            skip: 0,
            limit: 999999
        },
           json_fields: {
            'Nome Fantasia': 'companyUser.company.fantasyName',
            'Telefone': 'companyUser.company.primaryPhone',
            'Email': 'companyUser.company.email',
            'CNPJ': 'companyUser.company.document'
        },
        json_data: [
            {
                companyUser:{
                    company:{
                        fantasyName: null,           
                        primaryPhone: null,
                        email: null,
                        document: null
                    }
                },
            },  
        ],
        json_meta: [
			[{
				"key": "charset",
				"value": "utf-8"
			}]
		],
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
